// extracted by mini-css-extract-plugin
module.exports = {"subscriptionIcon":"SubscriptionIcon__subscriptionIcon"};